<ng-container *ngIf="config != null">
  <div class="d-flex">
    <div class="me-3">
      <h1 class="page-title mb-0">Print Checks</h1>
      <small>Paydate {{ config.Paydate | date: 'MM/dd/yyyy' }}</small>
    </div>
    <div class="flex-fill d-inline-flex justify-content-end">
      <div class="title-bar-btn">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_print_checks_return_to_start' }"
          class="btn btn-secondary me-3"
          (click)="navigateToStartPage()">
          Back
        </button>
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_print_checks_cancel' }"
          class="btn btn-secondary"
          (click)="navigateToPayrollHub()">
          Return to Payroll Hub
        </button>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12 col-md-9">
      <table class="table">
        <thead>
          <tr>
            <th>
              <lib-checkbox
                (ngModelChange)="selectAllChanged($event)"
                [ngModel]="selectAll"
                [id]="'chk_all'"
                [size]="checkSizes.Small"></lib-checkbox>
            </th>
            <th>Select (All)</th>
            <th>
              <span *ngIf="config.CheckType == 'ThirdParty'">Payee</span>
              <span *ngIf="config.CheckType == 'Employee'">Person</span>
            </th>
            <th *ngIf="config.CheckType == 'Employee' && config.HasDepartments">Department</th>
            <th *ngIf="config.CheckType == 'Employee' && config.HasDivisions">Division</th>
            <th *ngIf="config.CheckType == 'Employee'">Employee ID</th>
            <th>Check #</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let check of currentPage" [class.disabled]="check.printed">
            <td *ngIf="check.printed" colspan="2">Already Printed</td>
            <td *ngIf="!check.printed">
              <lib-checkbox
                (ngModelChange)="checkChanged($event, check)"
                [ngModel]="check.selected"
                [id]="'chk_' + check.checkNumber"
                [size]="checkSizes.Small"></lib-checkbox>
            </td>
            <td *ngIf="!check.printed"><i class="far fa-3x fa-user-circle"></i></td>
            <td>{{ check.name }}</td>
            <td *ngIf="config.CheckType == 'Employee' && config.HasDepartments">
              {{ check.department }}
            </td>
            <td *ngIf="config.CheckType == 'Employee' && config.HasDivisions">
              {{ check.division }}
            </td>
            <td *ngIf="config.CheckType == 'Employee'">{{ check.employeeId }}</td>
            <td>{{ check.checkNumber }}</td>
            <td>{{ check.total | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row mt-3 mb-3" *ngIf="records != null && records.length > 0">
    <div class="col-12">
      <lib-client-side-pagination
        [sendPageOnInit]="false"
        [collection]="records"
        (currentPage)="pageChanged($event)"></lib-client-side-pagination>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button
        (click)="submit()"
        [disabled]="selectedLines == null || selectedLines.length == 0"
        class="btn btn-primary">
        Print Selected
      </button>
    </div>
  </div>
</ng-container>
